import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameEvent from "../../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import ScenarioCommandEvent from "../../ngt/scenario/controller/ScenarioCommandEvent";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import ScenarioState from "../model/ScenarioState";
import { getURLParameter } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";


export default class StartScenarioCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);

        this.execute = function (event) {
            this.dispatch(ScenarioCommandEvent.INITIALIZE_SCENARIOS);

            if(gameModel.completed) {
                this.dispatch(GameEvent.COMPLETED);
                return;
            }

            // open debug episode if present in URL parameter
            const debugEpisodeId = getURLParameter("episode");
            if(ranj.DEBUG && !!debugEpisodeId) {
                this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, {
                    scenarioId: debugEpisodeId,
                });
                return;
            }

            // try to get an episode that has been started
            let startedScenario = gameModel.scenarioStates.find(scenarioState => scenarioState.state === ScenarioState.STATE_STARTED);
            if (!!startedScenario) {
                this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, {
                    scenarioId: startedScenario.id,
                });
            } else {
                // otherwise open episode selection
                this.gotoScreen(SkinKeys.EPISODE_SELECTION_SCREEN);
            }
        };
    }
}
